import type { ComponentProps } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { RotowireSmallLogo } from '@sorare/core/src/atoms/icons/RotowireLogo';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { Cost } from '@sorare/core/src/components/player/Cost';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';
import type { ProjectionDifference } from '@sorare/core/src/lib/scouting-center';

const Label = styled.span`
  font-size: var(--unit);
  font-weight: bold;
  line-height: 1;
  color: var(--c-white);
`;

const tooltipMessages: Record<ProjectionDifference, MessageDescriptor> = {
  [So5FixtureEvent.DAILY]: scoutingCenter.projectionDifferenceDaily,
  [So5FixtureEvent.CLASSIC]: scoutingCenter.projectionDifferenceClassic,
};

type Props = {
  mode: ProjectionDifference;
  color?: ComponentProps<typeof LabelS>['color'];
};

export const ProjectionDifferenceLabel = ({ mode }: Props) => {
  const inverted = mode === So5FixtureEvent.DAILY;

  return (
    <Tooltip
      title={
        <LabelS className="text-center">
          <FormattedMessage {...tooltipMessages[mode]} />
        </LabelS>
      }
    >
      <Cost
        size={3}
        color="var(--c-rotowire)"
        score={
          <Vertical gap={0} center>
            <RotowireSmallLogo size={1} />
            <Label>GAIN</Label>
          </Vertical>
        }
        inverted={inverted}
      />
    </Tooltip>
  );
};
